import type { IDisposable } from './IDisposable';

export class AutoEventSubscription implements IDisposable {
  private _removeEventListener?: () => void;

  public constructor(
    subject: EventTarget,
    type: string,
    listener: EventListenerOrEventListenerObject,
    options?: AddEventListenerOptions | boolean  
  ) {
    subject.addEventListener(type, listener, options);
    this._removeEventListener = (): void => {
      subject.removeEventListener(type, listener, options);
    };
  }

  public unsubscribe(): void {
    if (!this._removeEventListener) {
      throw new Error('Already unsubscribed');
    }
    this._removeEventListener();
    this._removeEventListener = undefined;
  }

  // IDisposable
  public dispose(): void {
    this.unsubscribe();
  }
}
